import Blog from './components/Blog';

function App() {
  return (
    <div className="App">
      <Blog />
    </div>
  );
}

export default App;
